<template>
    <pt-dialog-v2
        v-model="visible"
        v-bind="dialogProps"
        :custom-class="$style.refreshDialog"
        @confirm="handleClick"
    >
        <div :class="$style.title">{{ $t('common.app_ver_expire') }}</div>
    </pt-dialog-v2>
</template>

<script lang="ts">
import { computed, defineComponent, onMounted, onUnmounted, ref } from 'vue';
import useEventBus from '@assets/plugins/eventBus';
import { useI18n } from 'vue-i18n';
export default defineComponent({
    name: 'RefreshApp',
    setup() {
        const { eventBus } = useEventBus();
        const visible = ref(false);
        const { t } = useI18n();

        onMounted(() => {
            eventBus.$on('appVersionExpire', showPopup);
        });
        onUnmounted(() => {
            eventBus.$off('appVersionExpire', showPopup);
        });
        const dialogProps = computed(() => {
            return {
                title: t('common.app_ver_expire_title'),
                showCancelButton: false,
                showClose: false,
                size: 'small',
                confirmText: t('common.button_refresh')
            };
        });

        return {
            visible,
            dialogProps,
            showPopup,
            handleClick
        };
        function showPopup() {
            visible.value = true;
        }
        function handleClick() {
            window.location.reload();
        }
    }
});
</script>

<style lang="scss" module>
@import '@style/import.scss';
.title {
    font-size: 13px;
    color: $pt-black-300;
}
</style>
